module.exports = __webpack_public_path__ + "media/images/header_icons/search-fe96bdc4f7d67272bf2103940e59ee23.svg";